import React from "react";
import "../../../../css/Common/Components/DesignSystem/CheckBox.css";

// CheckBox component: A reusable checkbox input with error styling and controlled state
class CheckBox extends React.Component {
  // Handles the change event for the checkbox
  handleChange = (event) => {
    const { onChange } = this.props; // Extract the onChange prop

    // If an `onChange` prop is provided, call it with the event
    if (onChange) {
      onChange(event);
    }
  };

  render() {
    // Destructure props for easier access
    const { checked, name, className, error, ...rest } = this.props;

    return (
      <>
        {/* 
          Checkbox input:
          - Applies 'CheckBox' class and 'error' class if error is true
          - Controlled by the `checked` prop
          - Calls handleChange on change
          - Passes the `name` prop for form integration
        */}
        <input
          className={`CheckBox ${error === true ? "error" : ""}`} // Allow additional classes
          type="checkbox"
          checked={checked} // Use controlled prop
          onChange={this.handleChange} // Handle changes
          name={name} // Pass the name for form data handling
          // {...rest} // Spread any additional props if needed
        />
      </>
    );
  }
}

export default CheckBox;
